import React, {useContext,useEffect, useState,useRef} from 'react'
import moment from 'moment';
import $ from 'jquery'
import DataContext from "./../../data/DataContext";
import LothunService from '../../Services/Lothun.service';
import Swal from 'sweetalert2'
import './../../css/lothun.css'

function LothunPayMoney() {
    const dataConf = useContext(DataContext)
  const lothunService = new LothunService();

  const [lotzone,setLotzone] = useState([])
  const [lotdate,setLotdate] = useState([])

  const [lotType1,setLotType1] = useState([])
  const [lotType2,setLotType2] = useState([])
  const [lotType3,setLotType3] = useState([])
  const [lotType4,setLotType4] = useState([])
  const [lotType5,setLotType5] = useState([])
  const [lotTypeExtra,setLotExtra] = useState([])

  const[dataNumber,setDataNumber] = useState()

  const firstUpdate = useRef(true);
  useEffect(()=>{
    // if (firstUpdate.current) {
    //   firstUpdate.current = false;
    //   return;
    // }
    fetchLotZone()
  },[])

  const fup_date = useRef(true);
  useEffect(()=>{
    // if (fup_date.current) {
    //   fup_date.current = false;
    //   return;
    // }
    if(document.getElementById("p_lotzone").value === '') return
    fetchLotDate(document.getElementById("p_lotzone").value)
  },[lotzone])

  useEffect(()=>{
    //
  },[dataNumber])

  const fetchLotZone = ()=>{
      dataConf.blockUI(true)
      lothunService.listing_zone().then((result) => {
        dataConf.blockUI()
        if (result.success){
          setLotzone(result.data)
        }else{
          Swal.fire({
            title: result.message,
            text:'',
            icon: 'warning',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#890000',
        })
      }
    });
  }

  const fetchLotDate = (zone)=>{
    // dataConf.blockUI()
    lothunService.listing_date(zone).then((result) => {
      // dataConf.blockUI()
      if (result.success){
        setLotdate(result.data)
      }else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
      })
    }
  });
}

  const searchBill = (e)=>{
      e.preventDefault()
      const p_ok_id = e.target.p_lotdate.value
      const p_mcut = e.target.p_mcut.value 
      const p_namecut = e.target.p_namecut.value
      const p_mset = e.target.p_mset.value
      const p_lot_zone = e.target.p_lotzone.value
      dataConf.blockUI(true)
      lothunService.listing_billing(p_ok_id,p_mcut,p_namecut,p_mset,p_lot_zone).then((result) => {
        dataConf.blockUI()
          // console.log(result)
          if (result.success){
              setLotType1([])
              setLotType2([])
              setLotType3([])
              setLotType4([])
              setLotType5([])
              setLotExtra([])
              let lotEx = []
              Object.keys(result.data.moeny).map((i)=>{
                  // console.log(i)
                  if(i==='1'){
                    setLotType1(result.data.moeny[i])
                  }else if(i==='2'){
                    setLotType2(result.data.moeny[i])
                  }else if(i==='3'){
                    setLotType3(result.data.moeny[i])
                  }else if(i==='4'){
                    setLotType4(result.data.moeny[i])
                  }else if(i==='5'){
                    setLotType5(result.data.moeny[i])
                  }else {
                    lotEx.push({type:result.lot_type[i].name,id:i,value:result.data.moeny[i]})
                  }
                  
              })
              setLotExtra(lotEx)
              // console.log(lotTypeExtra)
          }else{
              if(result.status === 400) return;
              Swal.fire({
                  title: result.message,
                  text:'',
                  icon: 'warning',
                  confirmButtonText: 'ตกลง',
                  confirmButtonColor: '#890000',
            })
          }
      });
  }

  const onClkNumber = (e)=>{
      const param = {
        p_ok_id:$('#p_lotdate').val(),
        p_mset:$('#p_mset').val(),
        p_lot_zone:$('#p_lotzone').val(),
        p_number:e.target.getAttribute('data-number'),
        p_lot_type:e.target.getAttribute('data-type')
      }
      setDataNumber(param)
  }

  return (
    <div className="m-2" id="lothun-money">
        <form onSubmit={searchBill} id="frm_s_lothun">
          <div className="row g-3 align-items-center">
            <div className="col-auto">
              <label htmlFor="" className="col-form-label">ประเภทหวย :</label>
            </div>
            <div className="col-auto">
              <select className="form-select form-select-sm" onChange={(e)=>{fetchLotDate(e.target.value)}} id="p_lotzone">
                  {Object.keys(lotzone).map((i)=>{ return i==='1'?null:<option value={i} key={i}>{lotzone[i].name}</option>})}
              </select>
            </div>
            <div className="col-auto">
              <label htmlFor="" className="col-form-label">งวดวันที่ :</label>
            </div>
            <div className="col-auto">
              <div className="input-group">
                <select className="form-control form-control-sm" id="p_lotdate">
                    {lotdate.map((lot,i)=>{ return <option value={lot._id} key={i}>{moment(lot.limit_time).format('DD-MM-YYYY HH:mm')}</option>})}
                </select>
                <span className="input-group-text" id="basic-addon2"><img src="/calendar.png"/></span>
              </div>
            </div>
            <div className="col-auto">
              <label htmlFor="" className="col-form-label">ตัดส่ง :</label>
            </div>
            <div className="col-auto">
                <select className="form-select form-select-sm" id="p_mcut">
                  <option value="1">ทั้งหมด</option>
                  <option value="0">หุ้นเว็บ</option>
                </select>
            </div>
            <div className="col-auto">
                <select className="form-select form-select-sm" id="p_namecut">
                  <option value="1">เรียงตามยอด</option>
                  <option value="0">เรียงตามเลข</option>
                </select>
            </div>
            <div className="col-auto">
                <select className="form-select form-select-sm" id="p_mset">
                  <option value="0">ทั้งหมด</option>
                  <option value="1">แบบ A</option>
                  <option value="2">แบบ B</option>
                  <option value="3">แบบ C</option>
                </select>
            </div>
            <div className="col-auto">
              <button type="submit" className="btn btn-warning btn-sm">ค้นหา</button>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive mt-2">
          <table className="table table-bordered table-responsive text-center">
            <thead className="" >
              <tr>
                <th style={{width:'14%'}}>3บน</th>
                <th style={{width:'14%'}}>3ล่าง</th>
                <th style={{width:'14%'}}>3โต๊ด</th>
                <th style={{width:'14%'}}>2บน</th>
                <th style={{width:'14%'}}>2ล่าง</th>
                <th style={{width:'14%'}}>พิเศษ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{padding:0}}>
                  <table className="table table-bordered table-hover text-center table-type mb-0" style={{border:'1px rgb(190, 190, 190) solid'}}>
                    <thead className="">
                      <tr>
                        <th style={{minWidth:'30%'}}>เลข</th>
                        <th style={{minWidth:'30%'}}>ยอด</th>
                        <th style={{minWidth:'40%'}}>คาดเสีย</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotType1.map((money,i)=>{
                        return (
                          <tr key={i} >
                            <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={1}  onClick={onClkNumber}>{money.lot_number}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}} data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={1}  onClick={onClkNumber}>{dataConf.money_int.format(money.lot_money)}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={1}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>รวม</th>
                        <th>{dataConf.money_int.format(lotType1.reduce((v,e)=>{
                          return v + e.lot_money
                        },0))}</th>
                        <th>#</th>
                      </tr>
                    </tfoot>
                  </table>
                </td>
                <td style={{padding:0}}>
                <table className="table table-bordered table-hover text-center table-type mb-0" style={{border:'1px rgb(190, 190, 190) solid'}}>
                    <thead className="">
                      <tr>
                        <th style={{minWidth:'30%'}}>เลข</th>
                        <th style={{minWidth:'70%'}}>ยอด</th>
                        <th style={{minWidth:'40%'}}>คาดเสีย</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotType2.map((money,i)=>{
                        return (
                          <tr key={i}>
                            <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={2}  onClick={onClkNumber}>{money.lot_number}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={2}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_money)}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={2}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>รวม</th>
                        <th>{dataConf.money_int.format(lotType2.reduce((v,e)=>{
                          return v + e.lot_money
                        },0))}</th>
                        <th>#</th>
                      </tr>
                    </tfoot>
                  </table>
                </td>
                <td style={{padding:0}}>
                <table className="table table-bordered table-hover text-center table-type mb-0" style={{border:'1px rgb(190, 190, 190) solid'}}>
                    <thead className="">
                      <tr>
                        <th style={{minWidth:'30%'}}>เลข</th>
                        <th style={{minWidth:'70%'}}>ยอด</th>
                        <th style={{minWidth:'40%'}}>คาดเสีย</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotType3.map((money,i)=>{
                        return (
                          <tr key={i}>
                            <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={3}  onClick={onClkNumber}>{money.lot_number}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={3}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_money)}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={3}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>รวม</th>
                        <th>{dataConf.money_int.format(lotType3.reduce((v,e)=>{
                          return v + e.lot_money
                        },0))}</th>
                        <th>#</th>
                      </tr>
                    </tfoot>
                  </table>
                </td>
                <td style={{padding:0}}>
                <table className="table table-bordered table-hover text-center table-type mb-0" style={{border:'1px rgb(190, 190, 190) solid'}}>
                    <thead className="">
                      <tr>
                        <th style={{minWidth:'30%'}}>เลข</th>
                        <th style={{minWidth:'70%'}}>ยอด</th>
                        <th style={{minWidth:'40%'}}>คาดเสีย</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotType4.map((money,i)=>{
                        return (
                          <tr key={i}>
                            <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={4}  onClick={onClkNumber}>{money.lot_number}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}} data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={4}  onClick={onClkNumber}>{dataConf.money_int.format(money.lot_money)}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={4}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>รวม</th>
                        <th>{dataConf.money_int.format(lotType4.reduce((v,e)=>{
                          return v + e.lot_money
                        },0))}</th>
                        <th>#</th>
                      </tr>
                    </tfoot>
                  </table>
                </td>
                <td style={{padding:0}}>
                <table className="table table-bordered table-hover text-center table-type mb-0" style={{border:'1px rgb(190, 190, 190) solid'}}>
                    <thead className="">
                      <tr>
                        <th style={{minWidth:'30%'}}>เลข</th>
                        <th style={{minWidth:'70%'}}>ยอด</th>
                        <th style={{minWidth:'40%'}}>คาดเสีย</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotType5.map((money,i)=>{
                        return (
                          <tr key={i}>
                            <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={5}  onClick={onClkNumber} >{money.lot_number}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={5}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_money)}</td>
                            <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={5}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>รวม</th>
                        <th>{dataConf.money_int.format(lotType5.reduce((v,e)=>{
                          return v + e.lot_money
                        },0))}</th>
                        <th>#</th>
                      </tr>
                    </tfoot>
                  </table>
                </td>
                <td style={{padding:'5px'}}>
                  {/* พิเศษ */}
                    {lotTypeExtra.map((lot,i)=>{
                      return (
                        <table className="table table-bordered table-hover text-center table-type mb-2" style={{border:'1px rgb(190, 190, 190) solid'}} key={i}>
                          <thead className="">
                            <tr>
                                <th colSpan={2} style={{width:'30%'}}>{lot.type}</th>
                              </tr>
                              <tr>
                                <th style={{minWidth:'30%'}}>เลข</th>
                                <th style={{minWidth:'70%'}}>ยอด</th>
                                <th style={{minWidth:'40%'}}>คาดเสีย</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lot.value.map((money,i)=>{
                                return (
                                  <tr key={i}>
                                    <td data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={lot.id}  onClick={onClkNumber} >{money.lot_number}</td>
                                    <td style={{backgroundColor:'#ffe3e3',cursor:'pointer'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={lot.id}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_money)}</td>
                                    <td style={{backgroundColor:'#ffe3e3',cursor:'pointer',color:'red'}}  data-bs-toggle="modal" data-bs-target="#modalDetails" data-number={money.lot_number} data-type={lot.id}  onClick={onClkNumber} >{dataConf.money_int.format(money.lot_paymoney)}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                            <tfoot>
                              <tr>
                                <th>รวม</th>
                                <th>{dataConf.money_int.format(lot.value.reduce((v,e)=>{
                                  return v + e.lot_money
                                },0))}</th>
                                <th>#</th>
                              </tr>
                            </tfoot>
                        </table>
                       )
                    })} 
                    
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <DetailsNumber dataNumber={dataNumber} />
    </div>
  )
}

export default LothunPayMoney

function DetailsNumber(props) {
    const dataConf = useContext(DataContext)
    const lothunService = new LothunService();
    const [dataDetails,setDataDetails] = useState([])
  
    useEffect(()=>{
      if(props.dataNumber === undefined) return;
      setDataDetails([])
      fetchDetails()
    },[props.dataNumber])
  
    useEffect(()=>{
      // console.log(dataDetails)
    },[dataDetails])
  
    const fetchDetails = ()=>{
      dataConf.blockUI(true)
      lothunService.listing_details(props.dataNumber.p_ok_id,props.dataNumber.p_mset,props.dataNumber.p_lot_zone,props.dataNumber.p_number,props.dataNumber.p_lot_type).then((result) => {
        dataConf.blockUI()
        if (result.success){
          // console.log(result)
          setDataDetails(result.data.list)
        }else{
          Swal.fire({
            title: result.message,
            text:'',
            icon: 'warning',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#890000',
          })
        }
      });
    }
    return (
      <>
        <div className="modal fade" id="modalDetails" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">รายละเอียด</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <table className="table ">
                  <thead>
                    <tr>
                      <th scope="col">รหัสบิล</th>
                      <th scope="col">ซุปเปอร์</th>
                      <th scope="col">เมมเบอร์</th>
                      <th scope="col">วันที่ซื้อ</th>
                      <th scope="col">งวด</th>
                      <th scope="col">ประเภท</th>
                      <th scope="col">หมายเลข</th>
                      <th scope="col">จำนวนเงินที่เล่น</th>
                      <th scope="col">ถือสู้</th>
                      <th scope="col">คาดเดาเสีย</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-details">
                    {dataDetails.map((detail)=>{
                      return (
                        <tr key={detail.play_id}>
                          <td className="text-center">{detail.play_id}</td>
                          <td className="text-center">{detail.r_user}</td>
                          <td className="text-center">{detail.m_user}</td>
                          <td className="text-center">{moment(detail.play_datenow).format('DD-MM-YYYY HH:mm:ss')}</td>
                          <td className="text-center">{moment(detail.ok_date).format('DD-MM-YYYY')}</td>
                          <td className="text-center">{detail.lot_type_name}</td>
                          <td className="text-center">{detail.play_number}</td>
                          <td className="text-end">{dataConf.money_int.format(detail.b_total)}</td>
                          <td className="text-end">{dataConf.money_int.format(detail.b_total_share)}</td>
                          <td className="text-end text-danger">{dataConf.money_int.format(-detail.guess_loss)}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colSpan="6"></th>
                      <th>รวม:</th>
                      <th className="text-end b_total">
                        {dataConf.money_int.format(dataDetails.reduce((v,e)=>{
                          return v+e.b_total;
                        },0))}
                      </th>
                      <th className="text-end b_total_share">
                      {dataConf.money_int.format(dataDetails.reduce((v,e)=>{
                          return v+e.b_total_share;
                        },0))}
                      </th>
                      <th className="text-end guess_loss text-light">
                      {dataConf.money_int.format(-dataDetails.reduce((v,e)=>{
                          return v+e.guess_loss;
                        },0))}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ปิด</button>
              </div>
            </div>
          </div>
        </div>
  
      </>
    )
  }